import React, { useEffect, useState, useRef } from "react";
import Styles from "./Home.module.scss";
import clsx from "clsx";
import dowload from "../../../Css/img/download.png";
import ClientHomeCarousel from "../../../Share/Component/Carousel";
import NewsComponent from "../../../Share/Component/News";
import SuportComponent from "../../../Share/Component/Suport";
import {
  login,
  signup,
  manualdownload,
  toLoginPageUrl,
} from "../../../Api/SubUrl";
import { Path } from "../../../Api/Path";
import MenuVTC from "../../../Share/Component/MenuVtc";

function ClientHome() {
  const listDaily = [
    {
      daily: "T2",
      listActivity: [
        { name: "Tống Kim", time: "11h 13h 15h 17h 21h 23h" },
        { name: "Liên đấu", time: "22h" },
        { name: "Phong Lăng Độ", time: "14h 20h20" },
        { name: "Hái Quả Huy Hoàng", time: "12h 22h" },
        { name: "Dã Tẩu", time: "cả ngày" },
        { name: "Viêm đế", time: "sẽ ra mắt sớm" },
      ],
    },
    {
      daily: "T3",
      listActivity: [
        { name: "Tống Kim", time: "11h 13h 15h 17h 23h" },
        { name: "Thiên tử", time: "21h" },
        { name: "Liên đấu", time: "22h" },
        { name: "Phong Lăng Độ", time: "14h 20h20" },
        { name: "Hái Quả Huy Hoàng", time: "12h 22h" },
        { name: "Dã Tẩu", time: "cả ngày" },
        { name: "Viêm đế", time: "sẽ ra mắt sớm" },
      ],
    },
    {
      daily: "T4",
      listActivity: [
        { name: "Tống Kim", time: "11h 13h 15h 17h 21h 23h" },
        { name: "Liên đấu", time: "22h" },
        { name: "Phong Lăng Độ", time: "14h 20h20" },
        { name: "Boss Đại Hoàng Kim", time: "20h30 20h40" },
        { name: "Hái Quả Huy Hoàng", time: "12h 22h" },
        { name: "Dã Tẩu", time: "cả ngày" },
        { name: "Viêm đế", time: "sẽ ra mắt sớm" },
      ],
    },
    {
      daily: "T5",
      listActivity: [
        { name: "Tống Kim", time: "11h 13h 15h 17h 23h" },
        { name: "Công thành chiến", time: "21h" },
        { name: "Liên đấu", time: "22h" },
        { name: "Phong Lăng Độ", time: "14h 20h20" },
        { name: "Hái Quả Huy Hoàng", time: "12h 22h" },
        { name: "Dã Tẩu", time: "cả ngày" },
        { name: "Viêm đế", time: "sẽ ra mắt sớm" },
      ],
    },
    {
      daily: "T6",
      listActivity: [
        { name: "Tống Kim", time: "11h 13h 15h 17h 21h 23h" },
        { name: "Liên đấu", time: "22h" },
        { name: "Phong Lăng Độ", time: "22h" },
        { name: "Boss Đại Hoàng Kim", time: "20h30 20h40" },
        { name: "Hái Quả Huy Hoàng", time: "12h 22h" },
        { name: "Dã Tẩu", time: "cả ngày" },
        { name: "Viêm đế", time: "sẽ ra mắt sớm" },
      ],
    },
    {
      daily: "T7",
      listActivity: [
        { name: "Tống Kim", time: "11h 13h 15h 17h 21h 23h" },
        { name: "Liên đấu", time: "22h" },
        { name: "Phong Lăng Độ", time: "22h" },
        { name: "Hái Quả Huy Hoàng", time: "12h 22h" },
        { name: "Dã Tẩu", time: "cả ngày" },
        { name: "Viêm đế", time: "sẽ ra mắt sớm" },
      ],
    },
    {
      daily: "CN",
      listActivity: [
        { name: "Tống Kim", time: "11h 13h 15h 17h 21h 23h" },
        { name: "Liên đấu", time: "22h" },
        { name: "Phong Lăng Độ", time: "22h" },
        { name: "Boss Đại Hoàng Kim", time: "20h30 20h40" },
        { name: "Hái Quả Huy Hoàng", time: "12h 22h" },
        { name: "Dã Tẩu", time: "cả ngày" },
        { name: "Viêm đế", time: "sẽ ra mắt sớm" },
      ],
    },
  ];

  const [dailyActy, setDailyActy] = useState("T2");
  const contentMainRef = useRef(null);
  const [contentMainHeight, setContentMainHeight] = useState(0);

  useEffect(() => {
    const daysOfWeek = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
    const today = new Date();
    const currentDay = daysOfWeek[today.getDay()];
    setDailyActy(currentDay);
  }, []);

  useEffect(() => {
    const updateContentMainHeight = () => {
      if (contentMainRef.current) {
        const height = contentMainRef.current.offsetHeight;
        setContentMainHeight(height);
        document.documentElement.style.setProperty(
          "--content-main-height",
          `${height}px`
        );
      }
    };

    // Delay nhỏ để đảm bảo DOM đã render xong
    const timeoutId = setTimeout(() => {
      updateContentMainHeight();
    }, 100);

    window.addEventListener("resize", updateContentMainHeight);

    // Sử dụng MutationObserver để theo dõi thay đổi nội dung
    const observer = new MutationObserver(() => {
      // Delay nhỏ để đảm bảo DOM đã cập nhật
      setTimeout(updateContentMainHeight, 50);
    });
    if (contentMainRef.current) {
      observer.observe(contentMainRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", updateContentMainHeight);
      observer.disconnect();
    };
  }, []);

  const handleDownload = () => {
    window.open(manualdownload, "_blank");
  };
  return (
    <div className={clsx(Styles.wrapmain)}>
      <div
        id="click"
        className={clsx(Styles.main, {
          [Styles.contentMainSmall]:
            contentMainHeight > 0 && contentMainHeight < 1000,
          [Styles.contentMainMedium]:
            contentMainHeight >= 1000 && contentMainHeight < 1500,
          [Styles.contentMainLarge]: contentMainHeight >= 1500,
        })}
      >
        <div ref={contentMainRef} className={clsx(Styles.contentMain)}>
          <div className={clsx(Styles.contentLeft)}>
            <div className={clsx(Styles.optionsButton)}>
              <div className={clsx(Styles.blockUserAcount)}>
                <div onClick={handleDownload} className={clsx(Styles.clip)}>
                  <img
                    onClick={handleDownload}
                    src={dowload}
                    alt="Download client"
                  />
                </div>
                <div className={clsx(Styles.reglog)}>
                  <button
                    className={clsx(Styles.reg)}
                    data-task="SignUp"
                    aria-label="Đăng ký"
                    onClick={() => window.location.assign(toLoginPageUrl(signup))}
                  ></button>
                  <button
                    className={clsx(Styles.log)}
                    data-task="Login"
                    aria-label="Nạp KNB"
                    onClick={() => window.location.assign(toLoginPageUrl(login))}
                  ></button>
                </div>
                <button
                  className={clsx(Styles.userAccount, Styles.widgetLogin)}
                  data-task="login"
                  aria-label="Đăng nhập"
                  onClick={() => window.location.assign(toLoginPageUrl(login))}
                ></button>
              </div>
            </div>
            <div className={clsx(Styles.daily)}>
              <h3>
                <span>Hoạt động ngày</span>
              </h3>
              <div className={clsx(Styles.dailyInner)}>
                <div className={clsx(Styles.tabs)}>
                  <ul>
                    {listDaily?.map((item) => {
                      return (
                        <li
                          onClick={() => setDailyActy(item.daily)}
                          key={item.daily}
                          className={clsx(
                            Styles.tabsItem,
                            dailyActy === item.daily && Styles.active,
                          )}
                        >
                          <p data-day={item.daily}>{item.daily}</p>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <div className={clsx(Styles.dailyContent)}>
                  <div
                    className={clsx(Styles.day)}
                    style={{ display: "block" }}
                  >
                    <div className={clsx(Styles.content)}>
                      {listDaily?.map((item) => {
                        if (dailyActy === item.daily) {
                          return item.listActivity?.map((item1, index) => {
                            return (
                              <div key={index} className={clsx(Styles.item)}>
                                <div className={clsx(Styles.name)}>
                                  {item1.name}
                                </div>
                                <div className={clsx(Styles.time)}>
                                  {item1.time}
                                </div>
                              </div>
                            );
                          });
                        }
                        return null;
                      })}

                      <p>&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={clsx(Styles.supportSocial)}>
              <div className={clsx(Styles.blockSocial)}>
                <h3>Facebook</h3>
                <div className="social">
                  <div
                    className="fb-page"
                    data-href={Path.Fanpage}
                    data-tabs="timeline"
                    data-width="328"
                    data-height="457"
                    data-small-header="false"
                    data-adapt-container-width="true"
                    data-hide-cover="false"
                    data-show-facepile="true"
                  >
                    <blockquote
                      cite={Path.Fanpage}
                      className="fb-xfbml-parse-ignore"
                    >
                      <a href={Path.Fanpage}>Tri Kỷ Trùng Phùng</a>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={clsx(Styles.contentCenter)}>
            <ClientHomeCarousel />
            <NewsComponent />
            <SuportComponent />
          </div>
          <MenuVTC />
        </div>
      </div>
    </div>
  );
}
export default ClientHome;
